import { ANIMATION_IDENTIFIERS, ExtraDrawAnimationConfig } from '@Animation/types'
import { Plus3NumberSelector } from './number-selector'
import { Plus3TransitionEffect } from './transition-effect'
import { getPlus3AssetPreloader } from './asset-preloader'
import { Plus3Number } from './number'
import { getPlus3TextureLoader } from './texture-loader'

export const PLUS_3_CONFIG = (identifier: ANIMATION_IDENTIFIERS): ExtraDrawAnimationConfig => {
  return {
    assetPreloader: getPlus3AssetPreloader(identifier),
    transition: Plus3TransitionEffect,
    numberSelector: Plus3NumberSelector,
    kenoNumber: Plus3Number,
    textureLoader: getPlus3TextureLoader(identifier),
  }
}
